var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.detailInfo.length)?_c('c-table',{attrs:{"data":_vm.detailInfo,"tableColumns":_vm.tableColumns}}):_c('div',[_vm._v("暂无申请历史！")])}
var staticRenderFns = []

export { render, staticRenderFns }